import request from './_https';
// querystring 在 node 14 後已經棄用，改為 URLSearchParams
import setQueryString from '../tools/helpers';

/** --------------------
 *  Hub
 *  ----------------- */
// 列出所有 Hub
export const api_Get_Hubs = (query = undefined) => request('get', `/hubs${setQueryString(query)}`);

// 列出指定 Hub，包含底下的 Sensor 資訊
export const api_Get_Hub_Detail = (params) => request('get', `/hubs/${params.hashID}`);

// 更新指定 Hub 資訊
export const api_Update_Hub = (params, data) => request('put', `/hubs/${params.hashID}`, data);

// 上傳 Hub 圖片
export const api_Store_Hub_Pic = (params, data) => {
  const _formData = new FormData();
  _formData.append('pic', data.pic);

  const _config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  };

  return request('post', `/hubs/${params.hashID}/pic`, _formData, _config);
};

/** --------------------
 * Probe
 * ------------------ */

// 列出指定 Hub 底下的 Probe
export const api_Get_Hub_Probes = (params) => request('get', `/hubs/${params.hashID}/probes`);

// 列出所有 modbus_id 跟對應的參數
export const api_Get_Probe_Types = () => request('get', '/probe_types');

// 新增指定 Hub 底下的 Probe
export const api_Create_Hub_Probe = (params, data) => request('post', `/hubs/${params.hashID}/probes`, data);

// 更新指定 Hub 底下的 Probe
export const api_Update_Hub_Probe = (params, data) => request('put', `/hubs/${params.hashID}/probes/${params.modbusID}`, data);

/** --------------------
 *  Admin
 *  ----------------- */
// 新增一筆 Hub 資訊
export const api_Create_Hub = (data) => request('post', '/admin/hubs', data);
